import { Badge } from "@/components/ui/badge";

const STATUS_STYLES = {
  success: "border-emerald-200 bg-emerald-50 text-emerald-800",
  pending: "border-amber-200 bg-amber-50 text-amber-800",
  review: "border-blue-200 bg-blue-50 text-blue-800",
  warning: "border-orange-200 bg-orange-50 text-orange-800",
  danger: "border-rose-200 bg-rose-50 text-rose-800",
  neutral: "border-slate-200 bg-slate-100 text-slate-700",
};

function resolveStatusVariant(status = "") {
  const normalized = String(status).trim().toLowerCase();

  if (["approved", "paid", "complete", "active", "aktiv", "geschlossen"].includes(normalized)) return "success";
  if (["pending", "eingegangen", "offen", "processing", "initiated"].includes(normalized)) return "pending";
  if (["in prüfung", "in pruefung", "vorsortiert"].includes(normalized)) return "review";
  if (["due", "expired", "ruhend"].includes(normalized)) return "warning";
  if (["rejected", "abgelehnt", "failed", "cancelled", "canceled", "rückläufer", "ruecklaeufer"].includes(normalized)) return "danger";
  return "neutral";
}

function resolveStatusLabel(status = "") {
  const normalized = String(status).trim().toLowerCase();
  if (normalized.includes("reexperts geprüft") || normalized.includes("reexperts gepruft") || normalized === "reexperts") {
    return "REEXPERT";
  }
  return status;
}

export default function StatusBadge({ status, testId, className = "" }) {
  const variant = resolveStatusVariant(status);
  const label = resolveStatusLabel(status);

  return (
    <Badge
      variant="outline"
      className={`${STATUS_STYLES[variant]} ${className}`.trim()}
      data-testid={testId}
    >
      {label}
    </Badge>
  );
}
